import React, { useEffect } from 'react';
import styles from './SignIn.module.css';
import AuthImage from '../components/AuthImage';
import Form from './Form';

const SignIn = () => {
  useEffect(() => {
    window.gtag('event', 'open_login_page')
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        <AuthImage />
      </div>

      <div className={styles.content}>
        <Form />
      </div>
    </div>
  )
}

export default SignIn;
